
seedWebServices.service('ContactService', ['$http', '$cacheFactory', 'TranslationService', function ($http, $cacheFactory, TranslationService) {

    var serviceCache = $cacheFactory('ContactService');

    var URL = '../Api/ContactApi/';

    this.resetCache = function () {
        serviceCache.removeAll();
    };

    this.getList = function (stringFilter) {
        var cache = serviceCache;
        return $http.get(URL, {
            params: { stringFilter: 'stringFilter' },
            cache: cache
        });
    };


    //this.get = function (id) {
    //    var cache = serviceCache;

        
    //    //var encodedId = encodeURIComponent(id)

    //    console.log('get ' + encodedId);

    //    return $http.get(URL + encodedId, {
    //        cache: cache
    //    });
    //};

    this.get = function (id) {
        var cache = serviceCache;
        
        console.log('get ' + id);

        return $http.get(URL + 'Get', {
            params: {id: id},
            cache: cache
        });
    };

    this.getContactsCount = function () {
        return $http.get(URL + '/GetContactsCount', {
            params: {},
            cache: serviceCache
        });
    };

    this.getContacts = function (filterString, options, skipNumber, takeNumber, sort) {
        return $http.put(URL + '/SearchContacts', { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort }, { cache: serviceCache });
    };

    this.activateSalesOrg = function (contactID, sapSalesOrg) {
        return $http.put(URL + '/ActivateSalesOrg', { contactID: contactID, sapSalesOrg: sapSalesOrg }, { cache: serviceCache });
    };

    this.getPaymentsQuery = function (query) {
        return $http.get(URL + 'GetPaymentsQuery', { params: { query: query }, cache: serviceCache });
    };

    this.getContactsColumns = function (column, filterString, skipSize, takeSize) {
        return $http.get(URL + '/GetContactsColumns', {
            params: { column: column, filterString: filterString, skipSize: skipSize, takeSize: takeSize  },
            cache: serviceCache
        });
    };

    this.getContactsByProduct = function (productID) {
        return $http.get(URL + '/GetContactsByProduct', {
            params: { productID: productID },
            cache: false
        });
    };

    this.saveContact = function (contact) {
        return $http.post(URL + '/SaveContact', contact, true);
    };

    this.editPreferences = function (item) {
        return $http.put(URL, { actionTag: 'EditPreferences', data: item });
    };

    this.saveLogo = function (data) {
        return $http.put(URL, { actionTag: 'SaveLogo', data: data });
    };

    this.saveProject = function (item) {
        return $http.put(URL, { actionTag: 'SaveProject', data: item })
    };

    this.deleteProject = function (id) {
        return $http.put(URL, { actionTag: 'DeleteProject', data: id })
    };

    this.getProjectsQuery = function (query) {
        return $http.get(URL + '/GetProjectsQuery', {
            params: { query: query },
            cache: serviceCache
        });
    };

    this.saveSalesOrg = function (item) {
        return $http.put(URL, { actionTag: 'SaveSalesOrg', data: item })
    };

    this.saveSpecs = function (specs) {
        return $http.put(URL, {actionTag: 'SaveSpecs', data: specs})
    };

    this.saveContactSpecs = function (specs) {
        return $http.put(URL, {actionTag: 'SaveContactSpecs', data: specs})
    };

    this.saveLogo = function (logo) {
        return $http.put(URL, {actionTag: 'SaveLogo', data: logo})
    };

    this.createLogo = function (logo) {
        return $http.post(URL + '/PostLogo', { data: logo })
    };

    this.getContactLogos = function () {
        var cache = serviceCache;
        return $http.get(URL + '/GetContactLogos', {
            params: {},
            cache: cache,
        });
    };

    this.getProductLogo = function (productID, contactID, materialID) {
        return $http.get(URL + '/GetProductLogo', {
            params: { contactID: contactID, productID: productID, materialID: materialID},
            cache: false,
            responseType: 'arraybuffer'
        });
    };

    this.getLogo = function (logoID) {
        var cache = serviceCache;
        return $http.get(URL + '/GetLogo', {
            params: { logoID: logoID },
            cache: cache,
            responseType: 'arraybuffer'
        });
    };

    this.getCountries = function () {
        var cache = serviceCache;
        return $http.get(URL + '/GetCountries', {
            params: {},
            cache: cache
        });
    };

    this.getContactProducts = function () {
        var cache = serviceCache;
        return $http.get(URL + '/GetContactProducts', {
            params: {},
            cache: cache
        });
    };

    this.saveContactProduct = function (contactProduct) {
        return $http.put(URL, { actionTag: 'SaveContactProduct', data: contactProduct })
    };

    this.saveProductContacts = function (data) {
        return $http.put(URL, { actionTag: 'SaveProductContacts', data: data })
    };

    this.removeContactProduct = function (contactProduct) {
        return $http.put(URL, { actionTag: 'RemoveContactProduct', data: contactProduct })
    };

    this.getProjects = function () {
        var cache = serviceCache;
        return $http.get(URL + '/GetProjects', {
            params: {},
            cache: cache
        });
    };

    this.getProjectSpecs = function (projectID) {
        var cache = serviceCache;
        return $http.get(URL + '/GetProjectSpecs', {
            params: {id: projectID},
            cache: cache
        });
    };

    this.getSpecs = function (id) {
        var cache = serviceCache;
        return $http.get(URL + '/GetSpecs', {
            params: {id: id},
            cache: cache
        });
    };

    this.getContactsSpecs = function () {
        var cache = serviceCache;
        return $http.get(URL + '/GetContactsSpecs', {
            params: {},
            cache: cache
        });
    };

    this.getContactSpecs = function (data) {
        var cache = serviceCache;
        return $http.get(URL + '/GetContactSpecs', {
            params: {materialID: data.materialID},
            cache: cache
        });
    };

    this.getContactSalesOrgs = function (contactID) {
        var cache = serviceCache;
        return $http.get(URL + '/GetContactSalesOrgs', {
            params: { contactID: contactID },
            cache: cache
        });
    };

    this.getContactPartners = function (contactID) {
        var cache = serviceCache;
        return $http.get(URL + '/GetContactPartners', {
            params: { contactID: contactID },
            cache: cache
        });
    };

    this.getContactsPayments = function () {
        var cache = serviceCache;
        return $http.get(URL + '/GetContactsPayments', {
            params: {},
            cache: cache
        });
    };

    this.getContactsQuery = function ( query) {
        var cache = serviceCache;
        return $http.get(URL + '/GetContactsQuery', {
            params: { query: query},
            cache: cache
        });
    };

    this.getProductsQuery = function (query) {
        var cache = serviceCache;
        return $http.get(URL + '/GetProductsQuery', {
            params: { query: query },
            cache: cache
        });
    };

    /*
    this.getDics = function (filterString, options, skipNumber, takeNumber, sort) {
        return $http.put(URL + '/SearchDics', { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort }, { cache: serviceCache });
    };
    */

    this.getRoutes = function (filterString, options, skipNumber, takeNumber, sort) {
        console.log('getRoutes ' + skipNumber);
        return $http.put(URL + '/GetRoutes', 
            { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort },
            { cache: serviceCache }
        );
    };

    this.getRoutesCount = function () {
        return $http.get(URL + '/GetRoutesCount', {
            cache: false
        });
    };

    this.getContactDrawings = function (filterString, options, skipNumber, takeNumber, sort) {
        return $http.put(URL + '/GetContactDrawings', 
            { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort },
            { cache: serviceCache }
        );
    };

    this.getContactDrawingsCount = function () {
        return $http.get(URL + '/GetContactDrawingsCount', {
            cache: false
        });
    };

    this.getSalesReps = function (filterString, options, skipNumber, takeNumber, sort) {
        return $http.put(URL + '/GetSalesReps',
            { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort },
            { cache: serviceCache }
        );
    };

    this.getSalesRepsCount = function () {
        return $http.get(URL + '/GetSalesRepsCount', {
            cache: false
        });
    };


    this.getRoutePoints = function (filterString, options, skipNumber, takeNumber, sort) {
        console.log('getRoutePoints ' + skipNumber);
        return $http.put(URL + '/GetRoutePoints',
            { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort },
            { cache: serviceCache }
        );
    };

    //this.getObjectsCount = function () {
    //    return $http.get(URL + '/GetObjectsCount', {
    //        cache: false
    //    });
    //};


    this.getShipOwners = function (filterString, options, skipNumber, takeNumber, sort) {
        console.log('getShipOwners ' + skipNumber);
        return $http.put(URL + '/GetShipOwners',
            { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort },
            { cache: serviceCache }
        );
    };


}]);